var _defs, _path, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrganization(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:80px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M596.91,729.49q-5.89,43.43-9.39,72.75T584,845.65q0,30.52,15.25,30.5,8.21,0,35.2-9.38T672,853.86c2.34-.77,4.29.59,5.87,4.11a27.38,27.38,0,0,1,2.34,11.14q0,9.42-75.68,41.66T485.44,943q-44.61,0-44.59-58.66,0-19.93,4.11-47.52t11.15-69.23q7-41.62,13.49-86.24t12.91-82.71q6.44-38.11,10.56-67.47t4.11-48.11q0-41.05-25.82-41.06a78.2,78.2,0,0,0-23.46,4.1q-12.93,4.13-38.72,13.5-9.4,2.36-9.39-15.26,0-10.56,89.76-46.34t126.13-35.79q31.68,0,31.68,36.38,0,16.44-8.21,62.18T623.89,550Zm61-551.46q0,31.68-31.09,62.77T557,271.9q-59.83,0-59.83-36.38,0-30.5,36.37-64.53t68.05-34Q657.93,137,657.92,178Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 540,
    cy: 540,
    r: 494.13
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganization);
export default __webpack_public_path__ + "static/media/organization.4801dcd87905b1d19b274d365da8d868.svg";
export { ForwardRef as ReactComponent };